export default function socialMediaShareJs(block) {
	if (!block) {
		return;
	}
	const socialShareWrap = block.querySelector(
		`.social-media-share-popup dialog .dialog-actions .wrapper-content .wrapper-content-icons a.social-media-copylink`
	);
	if (!socialShareWrap) {
		return;
	}

	socialShareWrap.addEventListener(
		'click',
		function (e) {
			handleClick(block, e, this.dataset.url);
		},
		false
	);
	console.log('🚀 ~ Social share wrapper copy link:', socialShareWrap);
}

async function handleClick(block, e, url) {
	e.preventDefault();
	try {
		navigator.clipboard.writeText(url);
		block.querySelector(
			'.social-media-share-popup dialog .dialog-actions .wrapper-content .social-media-message'
		).style.display = 'block';
		setTimeout(function () {
			block.querySelector(
				'.social-media-share-popup dialog .dialog-actions .wrapper-content .social-media-message'
			).style.display = 'none';
		}, 2000);
	} catch (err) {
		console.error('Failed to copy!', err);
	}
	console.log('Yay! Copied to clipboard.');
	return false;
}
